import Dialog from 'react-toolbox/lib/dialog';
import React, { Component } from 'react';
import CSSModules from 'helpers/CSSModulesUtil';
import Divider from 'components/fulcrum/divider/Divider';
import { compose, branch, renderNothing, mapProps } from 'recompose';
import Input from 'react-toolbox/lib/input';
import Dropdown from 'components/fulcrum/dropdown/FulcrumDropdown'
import { connect } from 'react-redux'
 
import { IconButton } from 'react-toolbox/lib/button'
import notifyHoc from 'containers/App/Notification/Notify'
import T from 'i18n-react'

import {productGpuSkuSelector} from '../View/selectors.js'


const InfoButton = notifyHoc(IconButton)


import {
  postFormEcid, 
  updateMessage, 
  updateLicense,
  updateText,
  updateToggle
} from './actions.js';

import { 
  hintSelector,
  licenseSelector,
  textSelector,
  toggleSelector
} from './selectors'

import { segmentSelector  } from 'containers/Project/View/selectors'

const licenseSource = [
    { value: 'MemoryQualification', label: 'MemoryQualification' },
  ];

const mapDispatchToProps = (dispatch) => {
    return {
      postFormEcid: () => dispatch(postFormEcid()),
      updateLicense: (license) => dispatch(updateLicense(license)),
      updateText: (text) => dispatch(updateText(text)),
      updateToggle: (toggle) => dispatch(updateToggle(toggle)),
      updateMessage: (hint) => dispatch(updateMessage(hint))
    };
}

  const mapStateToProps = (state) => {
    return {
      text: textSelector(state),
      license : licenseSelector(state),
      projectSegment: segmentSelector(state),
      toggle: toggleSelector(state),
      hint: hintSelector(state),
      sku: productGpuSkuSelector(state)
    }
  }
  
class DialogTest extends Component {


  isPreHopper = () => {
    if (this.props.sku) {
      const gpu = (this.props.sku.substring(0,2))
      if ((['TU', 'LH', 'GV', 'GP', 'GM', 'GA']).includes(gpu)) return true
      else return false
    }
  }

  validateECID = (text) => {
    
    const preHopperValidation = (ecid) => {
      // PRE-HOPPER:- only for ['TU', 'LH', 'GV', 'GP', 'GM', 'GA'] chips
      const rawHexRegex = RegExp('^[0-9A-Fa-f]{16,32}$')
      const shaRegex = RegExp('^[0-9A-Fa-f]{64}$')

      if ((rawHexRegex.test(ecid) == true) || (shaRegex.test(ecid) == true)){
          return (ecid.padStart(32,0))
      }
      else return false

    }

    const hopperValidation = (pdi) => {
      // const hopperValidate = RegExp('/^(0x)?[0-9A-Fa-f]{16}$')
      const hopperValidate =  RegExp('^(0x)?[0-9A-Fa-f]{16}$')
      if (hopperValidate.test(pdi)) return pdi
      else return false
    }

    if (this.isPreHopper()){
      var updatedEcid = preHopperValidation(text)
      if (updatedEcid) return updatedEcid
      else return false
    }
    else  {
      var pdi = (hopperValidation(text))
      if (pdi) return pdi
      else return false
    }
   
  }

  clearForm = () => {
    this.props.updateText('')
    this.props.updateMessage('')
  }
  
  handleToggle = () => {
    this.props.updateToggle(!this.props.toggle)
    this.clearForm()
  };

  hasDuplicates = (ecids) => {
    return ((new Set(ecids)).size !== ecids.length)
  }

  getMessage = () => {
    if (this.isPreHopper()) return 'ECID'
    else return 'PDI'
  }

  onSave = () => {
    this.props.updateText 
    this.props.updateLicense('MemoryQualification')

    var ecids = this.props.text.split('\n')

    ecids = ecids.map(ecid => 
      ecid.replace(' ', '')
    )


    // Checking if no ECID's entered.
    if (ecids[0] == ['00000000000000000000000000000000']){
      this.props.updateMessage(`Please enter ${this.getMessage()}s `)
    }
    // Max ECIDs to be entered = 32
    else if (ecids.length>32) {
      this.props.updateMessage(`Please enter a maximum of 32 ${this.getMessage()}s`)
    }
  
    //Checking for duplicate ECIDs
    else if (this.hasDuplicates(ecids)){
      this.props.updateMessage(`Please enter unique ${this.getMessage()}s`)
    }

    else {
      var isValid = true
      let counter = 0
      while (counter<ecids.length && isValid==true){
        var updatedEcid = this.validateECID(ecids[counter])
        if (updatedEcid != false){
          ecids[counter] = updatedEcid
        }
        else isValid=false
        counter = counter+1
      }
      if (isValid == true){
        this.props.updateText(ecids.join('\n'))
        this.props.postFormEcid()
        this.handleToggle()
      }
      else{
        this.props.updateMessage(this.getErrorMessage());
      }
      
    }
  }

  getErrorMessage = () => {
    if (this.isPreHopper()) return 'Please enter valid ECIDs'
    else return 'Please enter valid PDIs'
  }

  getInputMessage = () => {
    if (this.isPreHopper()) return 'pages.project.hulk.dialog.ecidInput'
    else return 'pages.project.hulk.dialog.pdiInput'
  }

  getInstructionMessage = () => {
    if (this.isPreHopper()) return 'pages.project.hulk.dialog.ecidMessage'
    else return 'pages.project.hulk.dialog.pdiMessage'
  }

  actions = [
    { label: "Cancel", onClick: this.handleToggle },
    { label: "Submit", onClick: this.onSave }
  ];

  render () {

    const {
      text,
      license,
      toggle,
      hint,
      sku,
      updateText,
      updateLicense,
      updateToggle,
      updateErrorMessage
    } = this.props

    return (
      <div>
        <Dialog
          actions={this.actions}
          active={toggle}
          onEscKeyDown={this.handleToggle}
          onOverlayClick={this.handleToggle}
          title={T.translate('pages.project.hulk.dialog.title')}
        >
            <div styleName='container'>
                <Divider styleName='topDivider'/>
                <div styleName='roleSelection'>
                  <div>
                    {T.translate('pages.project.hulk.dialog.licenseDropdown')}
                  </div>
                  <Dropdown hint= {T.translate('pages.project.hulk.dialog.licenseHint')} source={licenseSource} value={'MemoryQualification'} onChange={updateLicense}/>
                </div>

                <div styleName='messageContainer'>
                    <div style={{marginTop: '20px', marginBottom: '10px'}}>
                      {T.translate(this.getInputMessage())}
                    </div>  
                    {T.translate(this.getInstructionMessage())}
                    <Input styleName='message' error={hint}  value={text} onChange={updateText} rows={5} multiline/>
                </div>

            </div>
        </Dialog>
      </div>
    );
  }
}


const withConnect = connect(mapStateToProps, mapDispatchToProps)
const enhance = compose(
  withConnect
) 

export default enhance(DialogTest)
